/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {BaseComponent, DamElasticDTO, IdAndHeader} from 'compob2b-libs';
import {catchError, take} from 'rxjs/operators';
import {NgSelectComponent} from '@ng-select/ng-select'
import {FormsModule} from '@angular/forms'
import {NbButtonModule, NbCardModule} from '@nebular/theme'

@Component({
  templateUrl: './dam-unit-items.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgSelectComponent,
    FormsModule,
    NbCardModule,
    NbButtonModule
  ]
})
export class DamUnitItemsComponent extends BaseComponent implements OnInit {

  @Input() damItems: DamElasticDTO[] = [];

  damItemsSelect: IdAndHeader[] = [];
  countAllDamVersion: number = 0;
  selectedDamItemID: number;

  ngOnInit(): void {
    this.damItems.forEach(damItem => {
      let idAndHeader = <IdAndHeader>{};
      idAndHeader.id = damItem.id;
      idAndHeader.header = damItem.header + ' (' + damItem.countVersion + ')';
      this.countAllDamVersion += damItem.countVersion;
      this.damItemsSelect.push(idAndHeader);
    });
    this.cdr.detectChanges();
  }

  unitItems() {
    let itemsForUnit = this.damItems.filter(item => {
      if (item.id != this.selectedDamItemID) {
        return item.id;
      }
    });

    if (this.selectedDamItemID > 0) {
      this.compoApiService.post('/dam/items/unit', {
          damItemId: this.selectedDamItemID,
          damItemIds: itemsForUnit.map(item => item.id)
        })
        .pipe(take(1), catchError(err => this.handleError(err)))
        .subscribe(_ => {
          window.location.reload();
        });
    }
    this.cdr.detectChanges();
  }

}
